<template>
  <div class="finishingScreen" :class="{ 'ac-bg-black': ac }">
    <header-component
      :is-soon="false"
      img-left=""
      img-right="/trocachip/img/access.png"
      class="header-component"
      :backRoute="false"
    />
    <div class="change_chip_container">
      <span
        class="finishingScreenPage_title"
        :class="{ 'ac-color-white': ac }"
        v-html="title"
      ></span>
      <div class="change_chip_carousel">
        <slick-carousel v-bind="carouselSettings">
          <div
            v-for="(info, index) in pageMessages"
            :key="index"
            class="barcode_inst_infos"
          >
            <img :src="getImageSrc(info.image)" />
            <span v-html="info.text" class="barcode_inst_info_text"></span>
          </div>
        </slick-carousel>
      </div>
      <div class="registered_info">
        <span
          class="description_info"
          :class="{ 'ac-color-white': ac }"
          v-html="finishingScreenPage.subInfo"
        ></span>
      </div>
      <div class="time_page_info">
        <p class="description_time_page" :class="{ 'ac-color-white': ac }">
          {{ formattedTime }}
        </p>
      </div>
    </div>

    <footer class="progress_line">
      <div class="progress_line_blue" :style="dinamicStyle"></div>
    </footer>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import { mapState } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import emailStatus from "../services/emailStatus";
import BillingProfile from "../services/billingProfile";
import Order from "../services/order";
import eSim from "../services/eSim";

export default {
  name: "finishingScreen",
  components: {
    HeaderComponent,
    "slick-carousel": VueSlickCarousel,
  },
  data() {
    return {
      description: "",
      timerCounter: 0,
      pageMessages: [],
      carouselSettings: {
        arrows: false,
        autoplay: false,
        dots: true,
        draggable: false,
        infinite: false,
        swipe: true,
      },
      title: "",
      counterRetryEmailStatus: 0,
      counterRetryOrderService: 0,
      counterRetryReserve: 0,
      counterRetryChangeEmail: 0,
    };
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      document: (state) => state.document,
      config: (state) => state.config,
      customer: (state) => state.customer,
      initFlow: (state) => state.config["init_flow"],
      finishingScreenPage: (state) => state.config.finishingScreenPage || {},
      finishingTitles: (state) => state.config.finishingTitles,
      limitRetryEmailStatus: (state) => state.config.limitRetryEmailStatus,
      limitRetryOrderService: (state) => state.config.limitRetryOrderService,
      limitRetryChangeEmail: (state) => state.config.limitRetryChangeEmail,
      limitRetryReserva: (state) => state.config.limitRetryReserva,
      difficultCompleteExchangePage: (state) =>
        state.config.difficultCompleteExchangePage,
      pinToken: (state) => state.pinToken,
      reason: (state) => state.reason,
      pin: (state) => state.pin,
      code: (state) => state.code,
      timeToCallRetryChangeEmail: (state) =>
        state.config.timeToCallRetryChangeEmail,
      timeToCallRetryOrder: (state) => state.config.timeToCallRetryOrder,
      timeToCallRetryOrderPendingSibel: (state) =>
        state.config.timeToCallRetryOrderPendingSibel,
      timeToCallRetryEmailStatus: (state) =>
        state.config.timeToCallRetryEmailStatus,
      timeToCallRetryReserve: (state) => state.config.timeToCallRetryReserve,
      fullTimeLoading: (state) => state.config.fullTimeLoading,
    }),
    formattedTime() {
      const minutes = parseInt(this.timerCounter / 60);
      const seconds = parseInt(this.timerCounter % 60);

      let m = minutes.toString();
      if (m.length === 1) {
        m = `0${m}`;
      }

      let s = seconds.toString();
      if (s.length === 1) {
        s = `0${s}`;
      }

      return `${m}:${s}`;
    },
    dinamicStyle() {
      return {
        animation: `growWidth ${this.fullTimeLoading}s linear forwards`,
      };
    },
  },
  created() {
    this.pageMessages = this.config.processingStep;
  },
  mounted() {
    this.startTimer();
    if (this.$route.params.changeEmail) {
      this.title = this.$route.params.title;
      this.updateEmail();
    } else {
      this.title = this.$route.params.title;
      this.timerCounter = this.$route.params.countTime;
      this.callReserveEsim();
    }
  },
  methods: {
    nextFlow(flowSelected) {
      this.$store.commit("flowSelected", flowSelected);
      this.$router.push({ name: "difficultCompleteExchange" });
    },
    getImageSrc(imageName) {
      return require("../assets/images/" + imageName);
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timerCounter <= this.fullTimeLoading) {
          this.timerCounter += 1;
        } else {
          this.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timerInterval);
    },
    updateEmail() {
      BillingProfile.updateEmail(
        this.$route.params.email ? this.$route.params.email : ""
      )
        .then((response) => {
          const responseData = response.data;

          if (!responseData) return;

          if (responseData.interactionProtocol != "") {
            this.postEmailStatus(responseData.interactionProtocol);
          } else {
            this.$router.push({
              name: "timeOutEmail",
              params: {
                counter: this.timerCounter,
              },
            });
          }
        })
        .catch((e) => {
          console.error(e);
          this.counterRetryChangeEmail++;
          if (this.counterRetryChangeEmail != this.limitRetryChangeEmail) {
            console.log(this.timeToCallRetryChangeEmail);
            setTimeout(
              () => this.updateEmail(),
              this.timeToCallRetryChangeEmail
            );
          } else {
            if (this.customer.email) {
              this.$router.push({
                name: "timeOutEmail",
                params: {
                  counter: this.timerCounter,
                },
              });
            } else {
              this.$router.push({ name: "chipExchangeClosed" });
            }
          }
        });
    },
    postEmailStatus(interactionProtocol) {
      this.title = this.finishingTitles.updateEmailTitle;
      const interaction = {
        number: interactionProtocol,
        msisdn: this.customer.login,
      };

      emailStatus
        .emailStatus(interaction)
        .then((_) => {
          console.log(_);
          this.title = this.finishingTitles.bookingEsinTitle;
          this.callReserveEsim();
        })
        .catch((_) => {
          console.error(_);
          this.counterRetryEmailStatus++;
          if (
            this.counterRetryEmailStatus != this.limitRetryEmailStatus &&
            _.response.status == 423
          ) {
            setTimeout(
              () => this.postEmailStatus(interactionProtocol),
              this.timeToCallRetryEmailStatus
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleEmailStatus
            );
          }
        });
    },
    callReserveEsim() {
      eSim
        .reservaEsim()
        .then((response) => {
          this.title = this.finishingTitles.makingExchangeTitle;
          if (!response.data)
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );

          this.$store.dispatch("urlEsim", response.data.url);
          this.$store.dispatch("iccidEsim", response.data.simCard.iccid);
          this.orderService(response.data.simCard.iccid, response.data.url);
        })
        .catch(() => {
          this.counterRetryReserve++;
          if (this.counterRetryReserve != this.limitRetryReserva) {
            setTimeout(
              () => this.callReserveEsim(),
              this.timeToCallRetryReserve
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        });
    },
    orderService(iccid, urlEsim) {
      this.title = this.finishingTitles.finallyTitle;
      Order.getOrder(this.code, this.pinToken, iccid, this.reason, urlEsim)
        .then((response) => {
          if (response.data.internalCode == "1") {
            this.$store.dispatch("protocol", response.data.protocol);
            this.$router.push("/loadingProcess");
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.counterRetryOrderService++;

          if (
            error.response.status == 422 &&
            this.timerCounter <= this.fullTimeLoading
          ) {
            setTimeout(
              () => this.orderService(iccid, urlEsim),
              this.timeToCallRetryOrderPendingSibel
            );
          } else if (
            this.counterRetryOrderService != this.limitRetryOrderService &&
            this.timerCounter <= this.fullTimeLoading
          ) {
            this.title = this.finishingTitles.waitAminutinTitle;
            setTimeout(
              () => this.orderService(iccid, urlEsim),
              this.timeToCallRetryOrder
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        });
    },
    redirectToPageError(description) {
      this.$router.push({
        name: "difficultCompleteExchange",
        params: {
          description,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.finishingScreen {
  width: 100%;
  height: 100%;
  display: flex;

  .slick-dots li {
    margin: 0;
  }
  .slick-dots li button:before {
    font-size: 10px;
    margin: 0;
  }

  .slick-dots button:before {
    color: #bababa !important;
  }

  .slick-dots .slick-active button:before {
    color: #0026d9 !important;
  }

  // position: absolute;
  .change_chip_container {
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
    width: 90%;
    margin: 0 5%;
    // align-items: center;
    box-sizing: content-box;
    > img {
      margin-top: 42px;
    }
  }
  .finishingScreenPage_title {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-block-end: 0 !important;
    margin-top: 88px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    text-align: center;
    color: #000000;
    align-self: center;
  }
  .change_chip_carousel {
    margin-bottom: 56px;
  }
  .barcode_inst_infos {
    width: 309px;
    min-height: 48px;
    margin: 42px auto 33px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > img {
      height: auto;
      margin: auto;
      margin-bottom: 32px;
    }
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
  .registered_info {
    width: 309px;
    height: 48px;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    align-self: center;
    > .description_info {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #000000;
    }
  }
  .time_page_info {
    width: 309px;
    height: 48px;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    align-self: center;
    > .description_time_page {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
      text-align: center;
    }
  }
  .description_info {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
    color: #000000;
  }
  .finishingScreenPage_container-button {
    width: 100%;
    height: auto;
    margin-top: 28px;
    position: fixed;
    bottom: 0;
    justify-content: center;
    display: grid;
    align-items: center;
  }
  .finishingScreenPage_button {
    width: 286px;
    height: 52px;
    margin: 0 auto 24px auto;
    border-radius: 26px;
    border: solid 2px #003091;
    background: none;
    outline: none;
    font-size: 1em;
    text-align: center;
    color: #003091;
    &:hover {
      cursor: pointer;
      -webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      -moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      transition: 1s;
    }
  }
  .finishingScreenPage_subtitle {
    width: 309px;
    min-height: 48px;
    margin: 16px auto 23px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }

  .progress_line {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .timer {
    font-family: "timsans_bold";
    font-size: 16px;
    color: #ffffff;
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
  }

  .progress_line_blue {
    width: 0; /* Inicialmente, a largura é zero */
    height: 4px;
    display: flex;
    padding: 1px;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    position: relative;
    background-color: #0026d9;
    overflow: hidden;
    margin-top: 1.5rem;
  }

  @keyframes growWidth {
    to {
      width: 100%; /* A largura atinge 100% após 15 segundos */
    }
  }
}
</style>
